(function(){
	'use strict';
	angular.module('app.supplyChain')
		.service('supplierPerformanceSummaryService', supplierPerformanceSummaryService);

	function supplierPerformanceSummaryService($http, $timeout, URLS, slideInModalService, $rootScope, storeService) {
		var supplierScoreCardOpened = {};

		return {
			getSupplier: getSupplier,
			getLateDeliveryCauseDataBySupplier: getLateDeliveryCauseDataBySupplier,
			getDeliveryScoreDataBySupplier: getDeliveryScoreDataBySupplier,
			openSupplierScoreCard: openSupplierScoreCard
		};

		function getSupplier() {
			var url = URLS.host + String.format(URLS.suppliers, globalConfig.factory.id) + '?grouped=true';
			return $http.get(url)
				.then(getSupplierListComplete)
				.catch(getSupplierListFailed);

			function getSupplierListComplete(response) {
				return response.data;
			}

			function getSupplierListFailed(error) {
				return [];
			}
		}

		function getLateDeliveryCauseDataBySupplier(factoryNdxs, supplierNdxs) {
			var url = '/api/2/factndx/' + factoryNdxs;
			url += '/LateDeliveryCauses';
			var queryParams = {'supplierNdx': supplierNdxs, 'noOfRecords': 5};
			url = addQueryParam(url,
				null, queryParams, false);

			return $http.get(url)
				.then(getChartDataComplete)
				.catch(getChartDataFailed);

			function getChartDataComplete(response) {
				return response.data;
			}
			function getChartDataFailed(error) {
				return error;
			}
		}

		function getDeliveryScoreDataBySupplier(factoryNdxs, supplierNdxs) {
			var url = '/api/2/factndx/' + factoryNdxs;
			url += '/SupplierPerformanceReport/DeliveryScoreBySupplier';
			url = addQueryParam(url,
				null, { 'supplierNdx': supplierNdxs}, false);

			return $http.get(url)
				.then(getChartDataComplete)
				.catch(getChartDataFailed);

			function getChartDataComplete(response) {
				return response.data;
			}
			function getChartDataFailed(error) {
				return error;
			}
		}

		function clearSupplierscoreScopes() {
			angular.forEach(supplierScoreCardOpened, function (scorecardScope) {
				if (scorecardScope) {
					scorecardScope.closeDialog();
				}
			});
		}

		function getSiteNamesForSotd(siteIds) {
			var sites = siteIds.toString().split(',');
			var showMoreText = '';
			if (sites.length > 2) {
				showMoreText = ', ' + (sites.length - 2) + ' more...';
				sites = sites.splice(0, 2);
			}
			var siteNames = _.join(_.map(sites, function (siteId) {
				return globalConfig.user.authFacts[siteId]['alias'];
			}), ', ');

			return siteNames + showMoreText;
		}

		function openSupplierScoreCard(args) {
			var key = args.factoryNdx + '-' + args.supplierNdx;
			clearSupplierscoreScopes();
			var supplierScoreCardScope = $rootScope.$new();
			supplierScoreCardOpened[key] = supplierScoreCardScope;
			var instance;
			supplierScoreCardScope.leanDirFactoryNdxs = args.factoryNdx;
			supplierScoreCardScope.supplierNdxs = args.supplierNdx;
			supplierScoreCardScope.supplierName = args.supplierName;
			supplierScoreCardScope.supplierCode = args.supplierCode;
			supplierScoreCardScope.siteNames = getSiteNamesForSotd(args.factoryNdx);
			supplierScoreCardScope.isEmbedded = true;
			incomingData.factory = args.factoryNdx;
			incomingData.supplierNdxs = args.supplierNdx;
			incomingData.isScoreCard = true;
			incomingData.isRemote = true;
			$timeout(function () {
				instance = slideInModalService.openModal({
					scope: supplierScoreCardScope,
					templateUrl: '/application/f/supply-chain/supplier-performance/supplier-score-card-report.html',
					windowTemplateUrl: '/application/f/core/item-drilldown/item-drilldown-template.html'
				});
				instance.result.then(function () {
					//do nothing on success
				}, function() {
					supplierScoreCardScope.closeDialog();
				});
				instance.result.catch(function () {
					jQuery('.inlineEditDiv').unbind();
					jQuery('.inlineEditDiv').remove();
					delete supplierScoreCardOpened[key];
					supplierScoreCardScope.closeDialog();
				});
			}, 0);

			supplierScoreCardScope.closeDialog = function () {
				slideInModalService.closeModal();
				if (supplierScoreCardScope) {
					supplierScoreCardScope.$destroy();
				}
				delete supplierScoreCardOpened[key];
			};
		}
	}
})();
